// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mp-button{border-radius:0 6px 6px 0}mp-button.fully-rounded{border-radius:6px}mp-button.has-share-button.fully-rounded{margin-left:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
